var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "sticker patternmaker-patternmaker-view-thumbnails"
  }, [_vm.enableSwiper ? _c('div', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper"
  }, [_c('swiper', {
    ref: "swiper",
    class: ['patternmaker-patternmaker-view-thumbnails-wrapper-swiper', {
      'patternmaker-patternmaker-view-thumbnails-wrapper-swiper--no-loop': !_vm.swiperOptions.loop
    }],
    attrs: {
      "options": _vm.swiperOptions,
      "auto-update": false,
      "auto-destroy": false,
      "delete-instance-on-destroy": false,
      "cleanup-styles-on-destroy": false
    },
    on: {
      "touchEnd": _vm.stickerTouched,
      "slideChange": _vm.stickerSlideChanged
    }
  }, _vm._l(_vm.stickers, function (item, index) {
    return _c('swiper-slide', {
      key: index,
      class: ['patternmaker-patternmaker-view-item', {
        active: item.id === _vm.currentSticker,
        disabled: !_vm.enabled
      }],
      attrs: {
        "data-sticker-id": item.id
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.id === _vm.currentSticker,
        expression: "item.id === currentSticker"
      }],
      staticClass: "icon-check"
    }), _c('img', {
      staticClass: "background",
      attrs: {
        "src": item.thumb,
        "alt": item.display_name.default,
        "data-sticker-id": item.id,
        "data-sticker-group-name": item.originalGroup
      }
    })]);
  }), 1), _c('div', {
    class: ['patternmaker-patternmaker-view-thumbnails-wrapper-nav-wrapper', {
      'hide': !_vm.enableCarouselNavigation
    }]
  }, [_c('button', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-previous stickers",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-indicator-open",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  })]), _c('button', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-next stickers",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right-indicator-open",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })])])], 1) : _c('base-spinner', {
    attrs: {
      "size": "50",
      "position": "inherit"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }